import { render, staticRenderFns } from "./AIModel.vue?vue&type=template&id=6414e8db&scoped=true&"
import script from "./AIModel.vue?vue&type=script&lang=js&"
export * from "./AIModel.vue?vue&type=script&lang=js&"
import style0 from "./AIModel.vue?vue&type=style&index=0&id=6414e8db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6414e8db",
  null
  
)

export default component.exports